export const WEBVIEW_HEADER_HEIGHT_PX = 60

// Content centered inside the remaining viewport appears lower by half the header height.
export const AUTH_CONTENT_CENTER_OFFSET_PX = WEBVIEW_HEADER_HEIGHT_PX / 2
